import { BasePage } from '@/components/ui/base-page'

export function InsuranceAPIPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add InsuranceAPIPage specific content here */}
    </BasePage>
  )
}